import { useAppData } from './AppDataProvider';
import { planClient } from './plan-client';
import type { EditResult, PlanEdit } from './plan-service';
import { randomSeed } from './seed';

/**
 * DE: Plan ändern oder anlegen: gerechnet wird im Hintergrund, gespeichert über den Provider.
 * EN: Change or create a plan: calculated in the background, stored through the provider.
 */
export function usePlanEdits(): {
  edit: (edit: PlanEdit) => Promise<EditResult>;
  create: (kind: 'month' | 'week') => Promise<EditResult>;
} {
  const { runPlan, today } = useAppData();
  return {
    edit: (edit) => runPlan((data) => planClient().editPlan(data, today, edit)),
    create: (kind) => {
      // DE: Wird noch einmal gerechnet, bleibt der Zufallswert gleich.
      // EN: When it calculates again, the random seed stays the same.
      const seed = randomSeed();
      return runPlan(async (data) => ({
        stored: await planClient().createPlan(data, { kind, today, seed }),
      }));
    },
  };
}
